module.exports = __webpack_public_path__ + "98f248b06e99d2eb0af600cb220f846f.pdf";